import { HideContentFromServerRender } from '@components/primitives/HideContentFromServerRender'
import { Text } from '@components/primitives/Text'
import { trackEventWithFacebook } from '@lib/tracking'
import { TrackingEvents } from '@lib/tracking/TrackingEvents'
import { TrackingSources } from '@lib/tracking/TrackingSources'
import { getLatestDavinciBriefSummary } from '@modules/trials/helpers/getLatestDavinciBriefSummary'
import { getTrialBriefSummary } from '@modules/trials/helpers/getTrialBriefSummary'
import type { TrialAssociation } from '@modules/trials/types/TrialAssociation'
import { useState } from 'react'

export default function TreatmentsAndConditions({
  trial,
}: {
  trial: TrialAssociation
}) {
  const [isSummaryExpanded, expandSummary] = useState(false)

  const toggleSummaryExpansion = () => {
    expandSummary(!isSummaryExpanded)
    isSummaryExpanded
      ? trackEventWithFacebook(
          TrackingEvents.SUMMARIZE_TRIAL_DESCRIPTION_CLICKED,
          {
            source: TrackingSources.LISTING,
          },
        )
      : trackEventWithFacebook(TrackingEvents.EXPAND_TRIAL_SUMMARY_CLICKED, {
          source: TrackingSources.LISTING,
        })
  }

  return (
    <div>
      <Text
        className='whitespace-pre-line text-neutral600'
        element={'p'}
        styleName='p'
        value={
          isSummaryExpanded
            ? trial.detailedDescription
            : getTrialBriefSummary({
                briefSummary: trial.briefSummary,
                latestDavinciBriefSummary: getLatestDavinciBriefSummary(trial),
                nlpBriefSummary: trial.nlpBriefSummary,
              }) || trial.briefTitle
        }
      />
      <HideContentFromServerRender>
        <Text
          className='text-neutral500 underline hover:text-neutral600'
          onClick={toggleSummaryExpansion}
          styleName='p-small-strong'
          value={isSummaryExpanded ? 'See summary' : 'See full description'}
        />
      </HideContentFromServerRender>
    </div>
  )
}
